"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = exports.hooks = void 0;
var react_redux_1 = require("react-redux");
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.hooks = {};
exports.actionCreators = {
    postAdoptData: function (firstname) {
        console.log(firstname);
        var dispatch = react_redux_1.useDispatch();
        dispatch({ type: 'GOTO_PROCESS_STATE', processState: "underwriting" });
    },
    fetchWhiteLabel: function (data) {
        var dispatch = react_redux_1.useDispatch();
        console.log('fetch from actionCreator');
        fetch('api/whitelabel', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            console.log(data);
            if (data.isSuccess) {
                dispatch({ type: 'RECEIVE_WHITE_LABEL', data: data });
            }
        });
    }
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
var unloadedState = {
    isLoading: false,
    processState: "start",
    siteDraft: {
        siteDraftId: 0,
        borrower1NameFirst: "",
        borrower1NameLast: "",
        borrower2NameFirst: "",
        borrower2NameLast: "",
        loanApprovedLimit: 0,
        loanToValueLimit: 0,
        mileageLimitation: "",
        yearLimitation: "",
        yearLimitationYear: "",
        specialInstructions: "",
        loanOfficerName: "",
        loanOfficerEmail: "",
        loanOfficerPhone: "",
        loanOfficerFax: ""
    },
    creditUnion: {
        loginId: 0,
        name: "",
        address1: "",
        city: "",
        state: "",
        zip: "",
        phoneMain: "",
        faxMain: "",
        logoImageBase64: ""
    },
    siteDraftCheck: {
        siteDraftCheckId: 0,
        checkNumber: "",
        verificationCode: "",
        isVerified: false,
        isAdopted: false,
        dealerContactFullName: "",
        dealerName: "",
        vehicleAssetTypeId: 0,
        vehicleVin: "",
        vehicleColor: "",
        authorizationCode: "",
        authorizationReceiptBase64: ""
    }
};
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    console.log("reducer: " + incomingAction.type);
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_VERIFY_CHECK':
            return __assign(__assign({}, state), { isLoading: true });
        case 'RECEIVE_VERIFY_CHECK':
            console.log("RECEIVE_VERIFY_CHECK");
            return __assign(__assign({}, state), { isLoading: false, creditUnion: action.data.creditUnion, siteDraft: action.data.siteDraft, siteDraftCheck: action.data.siteDraftCheck });
        case "GOTO_PROCESS_STATE":
            console.log("GOTO_PROCESS_STATE");
            return __assign(__assign({}, state), { processState: action.processState });
        case 'REQUEST_ADOPT_SITEDRAFT':
            return __assign(__assign({}, state), { isLoading: true });
        case 'RECEIVE_ADOPT_SITEDRAFT':
            console.log("RECEIVE_VERIFY_CHECK");
            console.log(action.data);
            return __assign(__assign({}, state), { siteDraftCheck: __assign(__assign({}, state.siteDraftCheck), { authorizationCode: action.data.dealerAuthorizationCode, authorizationReceiptBase64: action.data.dealerAuthorizationReceiptBase64 }), isLoading: false });
        case 'RECEIVE_WHITE_LABEL':
            console.log("RECEIVE_WHITE_LABEL");
            return __assign(__assign({}, state), { creditUnion: action.data.creditUnion });
        default:
            return state;
    }
};
//# sourceMappingURL=VerifyCheck.js.map